/**
 * Suppresses host hard-kick (HOST_DOMINANCE → stopStream) only while an admin
 * peer is actually connected (elevated shells). Must not be set during prepare —
 * that traps Nonsole if Admin Connect never completes.
 */

let suppressHostDominanceKick = false;

export function setSuppressHostDominanceKick(suppress: boolean): void {
  suppressHostDominanceKick = suppress;
}

export function shouldSuppressHostDominanceKick(): boolean {
  return suppressHostDominanceKick;
}
